// Action creators extracted from MyCalendarModule.js

import React from "react";
import {
  UPDATE_STATE,
  UPDATE_DAILY_VIEW_STATE,
  UPDATE_VIEW_ONLY_TAGS_STATE,
  UPDATE_FULL_SCREEN_VIEW_DATA,
  SET_SELECTED_SYNC_CALENDAR,
  UPDATE_CALENDAR_SYNC_MODAL_STATE,
  UPDATE_EVENT_MODALV2_STATE,
  RESET_EVENT_MODALV2_STATE,
  UPDATE_WEEKLY_REPEAT_EVENT_SETTINGS,
  UPDATE_MONTHLY_SET_POSITIONS_REPEAT_EVENT_SETTINGS,
  UPDATE_MONTHLY_DAY_POSITIONS_REPEAT_EVENT_SETTINGS,
  UPDATE_DAILY_REPEAT_EVENT_SETTINGS,
} from "./MyCalendarConstants";

// Action Creators
export const updateState = data => {
  return {
    type: UPDATE_STATE,
    data,
  };
};

export const updateDailyViewState = data => {
  return {
    type: UPDATE_DAILY_VIEW_STATE,
    data,
  };
};

export const updateViewOnlyTagsState = data => {
  return {
    type: UPDATE_VIEW_ONLY_TAGS_STATE,
    data,
  };
};

export const updateFullscreenViewData = data => {
  return {
    type: UPDATE_FULL_SCREEN_VIEW_DATA,
    data,
  };
};

export const updateSyncCalendarModalState = data => {
  return {
    type: UPDATE_CALENDAR_SYNC_MODAL_STATE,
    data,
  };
};

export const updateSelectedSyncCalendar = data => {
  return {
    type: SET_SELECTED_SYNC_CALENDAR,
    data,
  };
};

export const updateEventModalV2 = data => {
  return {
    type: UPDATE_EVENT_MODALV2_STATE,
    data,
  };
};

export const setWeeklyRepeatEventSettings = data => {
  return {
    type: UPDATE_WEEKLY_REPEAT_EVENT_SETTINGS,
    data,
  };
};

export const setMonthlySetpositionsRepeatEventSettings = data => {
  return {
    type: UPDATE_MONTHLY_SET_POSITIONS_REPEAT_EVENT_SETTINGS,
    data,
  };
};

export const setMonthlyDayPositionsRepeatEventSettings = data => {
  return {
    type: UPDATE_MONTHLY_DAY_POSITIONS_REPEAT_EVENT_SETTINGS,
    data,
  };
};

export const setDailyRepeatEventSettings = data => {
  return {
    type: UPDATE_DAILY_REPEAT_EVENT_SETTINGS,
    data,
  };
};

export const resetEventModalV2 = () => {
  return {
    type: RESET_EVENT_MODALV2_STATE,
  };
};
